<template>
  <div class="list-games-item">
    {{ data.awayTeam.abbreviation }} @ {{ data.homeTeam.abbreviation }}
    {{ gameDate }}
  </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { format } from 'date-fns';

@Component({
  name: 'list-games-item',
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
})
export default class ListGamesItem extends Vue {
  get gameDate() {
    return format(this.data.startDate, 'h:mma');
  }
}
</script>
